const translation = [];

// let target = window.aerobile.translation;
let target = window && window.aerobile && window.aerobile.translation ? window.aerobile.translation : {};

let result = {};

class Lang {

    constructor() {
        result = target;
    }

    find(originalText) {
        for (let ot in result) {
            if (ot === originalText) return result[ot];
        }
        return false;
    }

    say(originalText) {
        const result = this.find(originalText);
        return result ? result : originalText;
    }

}

const lang = new Lang();

export default lang;


// WEBPACK FOOTER //
// ./src/lang.js